import classnames from 'classnames';
import React from 'react';

import '@eika/link-panel-style';
import { Polymorph } from '@eika/polymorph';

import { ListPanelProps } from './LinkPanelTypes';
import { Labels, PanelArrow, TextContent } from './components';
import useGenerateId from './hooks/useGenerateId';

export const ListPanel = ({
    url,
    title,
    textOne,
    textTwo,
    textThree,
    prefixContent,
    backgroundColor,
    labels,
    ariaLabel,
    className,
    icon,
    as,
    invertIcon = false,
    prefixTitleElement,
    ...rest
}: ListPanelProps): JSX.Element => {
    const textContent = { title, textOne, textTwo, textThree };
    const hasTextContent = textOne || labels || textTwo || textThree;
    const hasOnlyTitle = !textTwo || !textThree;

    const labelId = useGenerateId();

    return (
        <Polymorph
            as={as}
            className={classnames(
                'sgw-list-panel',
                'unstyled',
                { 'inverted-icon': invertIcon },
                { 'align-center': !hasTextContent },
                { 'has-icon': Boolean(icon) },
                { 'has-only-title': hasOnlyTitle },
                className,
            )}
            aria-labelledby={labelId}
        >
            <a
                className={classnames('sgw-list-panel__link', `style--${backgroundColor}`, {
                    'with-prefix-content': prefixContent !== undefined,
                })}
                href={url}
                aria-label={ariaLabel}
                {...rest}
            >
                <Labels className="sgw-list-panel__labels" labels={labels} />
                <span className="sgw-list-panel__icon-with-title">
                    {prefixContent && <div className="sgw-list-panel__prefix-content">{prefixContent}</div>}
                    {prefixTitleElement && <div className="sgw-list-panel__title-icon">{prefixTitleElement}</div>}
                    <TextContent id={labelId} prefixClass="sgw-list-panel" {...textContent} />
                </span>
                <PanelArrow className="sgw-list-panel__arrow-wrapper" show={Boolean(icon)} icon={icon} />
            </a>
        </Polymorph>
    );
};
